(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ponytail-gallery-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pt-catalog-card')) {
  customElements.define('pt-catalog-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.controls = this.querySelector('.pt-card__controls');
      this.status = this.querySelector('.pt-card__status');
      this.recovery = this.querySelector('.pt-card__recovery');
      this.querySelector('.pt-card__fallback').hidden = true;
      this.controls.hidden = false;
      const color = this.querySelector('select[data-color]');
      if (color) color.addEventListener('change', () => {
        let shown;
        this.querySelectorAll('[data-variant]').forEach(button => {
          button.hidden = button.dataset.color !== color.value;
          if (!button.hidden && !shown) shown = button;
        });
        if (shown) {
          this.querySelector('.pt-card__price').textContent = shown.dataset.price;
          const img = this.querySelector('.pt-card__photo');
          if (img && shown.dataset.image) {
            img.removeAttribute('srcset');
            img.src = shown.dataset.image;
          }
        }
        this.status.textContent = '';
        this.recovery.hidden = true;
      });
      this.form.addEventListener('submit', event => this.add(event));
    }
    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      const clicked = event.submitter;
      const id = clicked?.name === 'id' ? clicked.value : new FormData(this.form).get('id');
      if (!id || clicked?.disabled) return;
      this.busy = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.recovery.hidden = true;
      const buttons = this.form.querySelectorAll('button');
      buttons.forEach(button => { button.disabled = true; });
      const color = this.querySelector('select[data-color]');
      if (color) color.disabled = true;
      const drawer = document.querySelector('cart-drawer');
      const formData = new FormData(this.form);
      formData.set('id', id);
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        formData.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url', window.location.pathname);
        drawer.setActiveElement(clicked || this.form);
      }
      try {
        const response = await fetch(this.form.action + '.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        const data = await response.json();
        if (!response.ok || data.status) {
          this.status.textContent = typeof data.description === 'string' ? data.description : this.dataset.error;
          this.recovery.hidden = false;
          return;
        }
        this.status.textContent = this.dataset.added;
        if (drawer && data.sections && drawer.getSectionsToRender().every(section => data.sections[section.id])) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pt-catalog', productVariantId: id, cartData: data });
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch (error) {
        this.status.textContent = this.dataset.error;
        this.recovery.hidden = false;
      } finally {
        buttons.forEach(button => { button.disabled = button.dataset.soldOut === 'true'; });
        if (color) color.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.busy = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
